export const ArrowDown = (props: any) => {
  return (
    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1L5.5 5.5L10 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
